import React from "react";
import { Pencil } from "lucide-react";

export default function StoreConfigTable({ data, onEdit }) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      <table className="w-full">
        <thead>
          <tr className="bg-gray-50 border-b border-gray-200">
            <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700 w-24">
              Aksi
            </th>
            <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700 w-48">
              Informasi
            </th>
            <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">
              Deskripsi
            </th>
            <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700 w-48">
              Diupdate Oleh
            </th>
            <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700 w-48">
              Diupdate Tanggal
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {data.map((item, index) => (
            <tr key={index} className="hover:bg-gray-50 transition">
              <td className="px-6 py-4">
                <button
                  onClick={() => onEdit(item)}
                  className="w-8 h-8 bg-slate-700 text-white rounded-lg hover:bg-slate-800 flex items-center justify-center transition-colors"
                  title="Edit">
                  <Pencil className="w-3.5 h-3.5" />
                </button>
              </td>
              <td className="px-6 py-4 text-sm text-gray-900">{item.label}</td>
              <td className="px-6 py-4 text-sm text-gray-700">
                {item.type === "image" ? (
                  <div className="w-16 h-16 bg-slate-50 border border-slate-200 rounded-lg flex items-center justify-center overflow-hidden">
                    {item.value ? (
                      <img
                        src={item.value}
                        alt="Logo"
                        className="w-full h-full object-contain"
                      />
                    ) : (
                      <span className="text-slate-400 text-xs font-medium">No Logo</span>
                    )}
                  </div>
                ) : item.type === "toggle" ? (
                  <div className={`inline-flex px-3 py-1 rounded-full text-xs font-semibold ${item.value === "Aktif" ? "bg-teal-100 text-teal-700" : "bg-slate-100 text-slate-700"}`}>
                    {item.value}
                  </div>
                ) : (
                  <div className="text-gray-900 whitespace-pre-line">
                    {item.value || "-"}
                  </div>
                )}
              </td>
              <td className="px-6 py-4 text-sm text-gray-600">
                {item.updatedBy}
              </td>
              <td className="px-6 py-4 text-sm text-gray-600">
                {item.updatedAt}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
